import ProductIcon from '@mui/icons-material/Collections';
import SacopList from './SacopList';

export default {
    list: SacopList,
    icon: ProductIcon,
};